export interface PurchaseOrderDeliveryReport {
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  value: number;
  notes: string;
  currencySymbol: string;
  quantityString: string;
  priceString: string;
  valueString: string;
}
